module.exports = __webpack_public_path__ + "img/logo_121x120.6d27a22b.png";